import * as React from 'react';
const h = React.createElement;
import { icons } from '../icons';

export interface DrawerProps {
  title?: React.ReactNode;
  open?: boolean;
  onClose?: () => void;
  width?: number | string;
  placement?: 'left' | 'right';
  children?: React.ReactNode;
}

const Drawer: React.FC<DrawerProps> = function Drawer(props) {
  const { title, open, onClose, width = 400, placement = 'right', children } = props;
  if (!open) return null;

  const isRight = placement === 'right';
  return h(
    'div',
    { className: 'fixed inset-0 z-[9998]' },
    h('div', { className: 'fixed inset-0 bg-black/60', onClick: onClose }),
    h(
      'div',
      {
        className: `fixed top-0 bottom-0 ${isRight ? 'right-0' : 'left-0'} bg-dark-800 border-${isRight ? 'l' : 'r'} border-dark-700 shadow-2xl transform transition-transform duration-300`,
        style: { width },
      },
      h(
        'div',
        { className: 'flex items-center justify-between p-4 border-b border-dark-700' },
        h('h3', { className: 'text-base font-semibold text-white' }, title),
        h(
          'button',
          { className: 'text-dark-400 hover:text-white', onClick: onClose },
          h(icons.CloseCircleOutlined),
        ),
      ),
      h(
        'div',
        { className: 'p-4 overflow-y-auto', style: { maxHeight: 'calc(100vh - 60px)' } },
        children,
      ),
    ),
  );
};

export { Drawer };
